import { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../context/languageContext"; // ✅ add this
import axios from "axios";


const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [playSound, setPlaySound] = useState(false);
  const [score, setScore] = useState(500);

  const menuRef = useRef();

  const { lang, changeLanguage } = useLanguage(); // ✅ language hook

  const user = JSON.parse(localStorage.getItem("user"));
  const isLoggedIn = !!user;

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  useEffect(() => {

    if (!user) return;

    axios
      .get(
        `https://edunet.kmechengineering.com/root-engine1/api/user-score?user_id=${user.id}`
      )
      .then((res) => {
        if (res.data.status) {
          setScore(res.data.score);
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");

      if (!navbar) return;

      if (window.scrollY <= 10) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      } else {
        navbar.style.transform = "translateX(-50%) translateY(-140%)";
        navbar.style.opacity = "0";
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
     {/* {playSound && (
        <audio
          src="/sound/menu.mp3"
          autoPlay
          onEnded={() => setPlaySound(false)}
        />
      )} */}

      <nav
        className="navbar"
        style={{
          position: "fixed",
          top: "18px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "85%",
          maxWidth: "850px",
          zIndex: "9999",
          transition: "all 0.35s ease"
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "45px"
          }}
        >
          {/* Center Logo */}
          <div
            className="navbar-brand"
            onClick={() => {
              const newState = !open;
              setOpen(newState);
              if (newState) setPlaySound(true);
            }}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            <img src="/logo2.png" alt="logo" className="navbar-logo" />

            <span className="navbar-text">
              Edunet
            </span>
          </div>


          {/* Right Score */}
          {isLoggedIn && (
            <div
              onClick={() => (window.location.href = "/score-dashboard")}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                background: "linear-gradient(135deg,#FFD700,#FFC107)",
                color: "#000",
                padding: "4px 10px",
                borderRadius: "16px",
                fontWeight: "bold",
                fontSize: "13px",
                cursor: "pointer"
              }}
            >
              🪙 {score}
            </div>
          )}

        </div>
      </nav>

      {open && (
        <>
          {/* Confetti */}
          <div className="confetti-container">
            {[...Array(60)].map((_, i) => (
              <div
                key={i}
                className="confetti"
                style={{
                  left: Math.random() * 100 + "%",
                  backgroundColor: `hsl(${Math.random() * 360}, 80%, 60%)`,
                  animationDuration: 1 + Math.random() * 2 + "s",
                  animationDelay: Math.random() * 2 + "s"
                }}
              />
            ))}
          </div>

          {/* Overlay */}
          <div
            className="popup-overlay"
            onClick={() => setOpen(false)}
          ></div>

          {/* Popup Menu */}
          <div className="menu-popup" ref={menuRef}>
            <ul>
              <li>
                <NavLink to="/" onClick={() => setOpen(false)}>
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink to="/about" onClick={() => setOpen(false)}>
                  About
                </NavLink>
              </li>

              <li>
                <NavLink to="/services" onClick={() => setOpen(false)}>
                  Services
                </NavLink>
              </li>

              <li>
                <NavLink to="/gallery" onClick={() => setOpen(false)}>
                  Gallery
                </NavLink>
              </li>

              <li>
                <NavLink to="/contact" onClick={() => setOpen(false)}>
                  Contact
                </NavLink>
              </li>

              {!isLoggedIn ? (
                <>
                  <li>
                    <NavLink to="/auth" onClick={() => setOpen(false)}>
                      Sign In
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/auth" onClick={() => setOpen(false)}>
                      Register
                    </NavLink>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <NavLink to="/profile" onClick={() => setOpen(false)}>
                      My Profile
                    </NavLink>
                  </li>

                  <li>
                    <button onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </>
              )}

              {/* ✅ LANGUAGE SWITCH */}
              <li style={{ marginTop: "12px" }}>
                <select
                  value={lang}
                  onChange={(e) => {
                    changeLanguage(e.target.value);
                    setOpen(false); // optional close menu
                  }}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    background: "#f5f5f5"
                  }}
                >
                  <option value="en">English</option>
                  <option value="si">සිංහල</option>
                  <option value="ta">தமிழ்</option>
                </select>
              </li>
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;


